import { NgModule } from '@angular/core';

import { DisallowedOptimizationBannerComponent } from '@app/shared/modules/disallowed-optimization/components/disallowed-optimization-banner.component';
import { DisallowedOptimizationMessageComponent } from '@app/shared/modules/disallowed-optimization/components/disallowed-optimization-message.component';
import { DisallowedOptimizationTitleComponent } from '@app/shared/modules/disallowed-optimization/components/disallowed-optimization-title.component';
import { DisallowedOptimizationTooltipComponent } from '@app/shared/modules/disallowed-optimization/components/disallowed-optimization-tooltip.component';

@NgModule({
  imports: [
    DisallowedOptimizationBannerComponent,
    DisallowedOptimizationMessageComponent,
    DisallowedOptimizationTitleComponent,
    DisallowedOptimizationTooltipComponent,
  ],
  exports: [DisallowedOptimizationBannerComponent, DisallowedOptimizationTooltipComponent],
})
export class DisallowedOptimizationModule {}
